
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VTextarea from 'vuetify/lib/components/VTextarea/VTextarea';
import Vue, { CreateElement, VNode } from 'vue';
const base = Vue.extend({ mixins: [VTextarea] });

export default base.extend({
    name: 'base-textarea',
    props: {
        outlined: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    },
    computed: {
        classes(): object {
            return {
                ...VTextarea.options.computed.classes.call(this),
                'base-text-field': true,
                'base-text-area': true
            };
        },
        computedProps(): object {
            const props = { ...this.$props };
            props.outlined = true;
            return props;
        }
    },
    render(h: CreateElement): VNode {
        const textFieldArea = h(
            VTextarea,
            {
                class: this.classes,
                props: {
                    ...this.computedProps
                },
                on: this.$listeners,
                scopedSlots: this.$scopedSlots,
                attrs: this.$attrs
            },
            this.$slots.default
        );
        return h('div', { class: 'text-wrapper' }, [
            this.label ? h('div', { class: 'text-title' }, this.label) : null,
            textFieldArea
        ]);
    }
});
